import { Button, Spinner } from "@shapr3d/frontend-lib";
import type React from "react";

import { useTracker } from "../../hooks/useTracker";

import style from "./ModelViewerOverlay.module.css";

interface ModelViewerOverlayProps {
  progress?: number;
  error?: boolean;
  onRetry?: () => void;
}

const ModelViewerOverlay: React.FC<ModelViewerOverlayProps> = ({
  progress = 0,
  error,
  onRetry,
}) => {
  const tracker = useTracker();
  if (error) {
    return (
      <div className={style.modelViewerContainer}>
        <div className={style.errorContainer}>
          <div className={style.errorTitle}>Something went wrong</div>
          <div>Please try loading the design again.</div>
          <Button
            disabled={false}
            onClick={() => {
              tracker.trackButtonClick({ elementId: "webviewer-reload" });
              onRetry?.();
            }}
          >
            Reload
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className={style.modelViewerContainer}>
      <div>
        <Spinner />
        <div className={style.percentageIndicator}>{progress}%</div>
      </div>
    </div>
  );
};

export default ModelViewerOverlay;
